import { BufferWriter, Writer } from "protobufjs";
import { IClientBrowsingHistoryRepository } from "src/domain/repository/client_browsing_history_repository";
import { ClientBrowsingHistory } from "../../../domain/model/client_browsing_history";
import { IApiClient } from "../client";
import { common, entity } from "../rpc/api";
import { getToken } from "./bind_token";
import ClientBrowsingHistoryList = entity.ClientBrowsingHistoryList;
import CustomerID = entity.CustomerID;
import Empty = common.Empty;
import Pager = common.Pager;
import Count = common.Count;

import {
  ClientBrowsingHistoryConvertResponse,
  ClientBrowsingHistoryConvertResponseList,
} from "./client_browsing_history_api_convert";

class ClientBrowsingHistoryAPI implements IClientBrowsingHistoryRepository {
  constructor(readonly apiClient: IApiClient) {}

  public getAllByClient(
    page: number,
    offset: number
  ): Promise<ClientBrowsingHistory[]> {
    return new Promise<ClientBrowsingHistory[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: Pager = new Pager();
          req.page = page;
          req.offset = offset;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ClientBrowsingHistoryService/GetAll",
            token,
            Pager.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: ClientBrowsingHistoryList =
            ClientBrowsingHistoryList.decode(binary);
          // BE=>FE 型変換
          const resConverted: ClientBrowsingHistoryConvertResponseList =
            ClientBrowsingHistoryConvertResponseList.from(res);
          const items: ClientBrowsingHistory[] = resConverted.items.map(
            (
              item: ClientBrowsingHistoryConvertResponse
            ): ClientBrowsingHistory => {
              return ClientBrowsingHistory.from(item);
            }
          );
          resolve(items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public getCountByClient(): Promise<number | Long> {
    return new Promise<number | Long>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: Empty = new Empty();
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ClientBrowsingHistoryService/GetCount",
            token,
            Empty.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: Count = Count.decode(binary);
          const item: number | Long = res.count;
          resolve(item);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public create(customerID: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: CustomerID = new CustomerID();
          req.id = customerID;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ClientBrowsingHistoryService/Create",
            token,
            CustomerID.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          resolve();
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }
}

const createClientBrowsingHistoryAPI = (
  apiClient: IApiClient
): IClientBrowsingHistoryRepository => {
  return new ClientBrowsingHistoryAPI(apiClient);
};

export { createClientBrowsingHistoryAPI };



// WEBPACK FOOTER //
// ./src/infra/api/service/client_browsing_history_api.ts